// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2e-7R","title":"ClientCherryInfo_title__3Ixy3","itemText":"ClientCherryInfo_itemText__FOOJu"};